"use client";

import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { useTranslations } from "next-intl"


interface ChannelQrProps {
  /** The value to encode (e.g. a Telegram deep link). */
  value: string;
  /** Pixel size of the rendered QR image. */
  size?: number;
}

/**
 * Render a value as a scannable QR code. Generation runs client-side via the
 * `qrcode` lib; an operator on a phone scans it to open the Telegram deep link.
 */
export function ChannelQr({ value, size = 180 }: ChannelQrProps) {
  const tUi = useTranslations("NotificationChannels.NotificationChannelsChannelQr")

  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(value, { width: size, margin: 1 })
      .then((url) => {
        if (!cancelled) setDataUrl(url);
      })
      .catch((err) => {
        console.error("[ChannelQr] failed to render QR:", err);
        if (!cancelled) setDataUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, [value, size]);

  if (!dataUrl) {
    return (
      <div
        className="animate-pulse rounded-md bg-muted"
        style={{ width: size, height: size }}
        aria-hidden
      />
    );
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element -- data-URL QR, not a remote asset
    <img src={dataUrl} alt={tUi("qRCodeForTheTelegramEnrollmentLink")} width={size} height={size} />
  );
}
